export const mockPartners = [
  {
    id: 'partner-001',
    nickname: '田中 美咲',
    partner_role: '看護師',
    area: '宮城県仙台市',
    workplace: {
      name: '仙台市立病院 小児科',
      url: 'https://hospital.city.sendai.jp/',
    },
    sns: {
      instagram: 'https://instagram.com/misaki_nurse',
      twitter: '',
      line: '',
    },
    bio: '小児科で10年以上の経験を持つ看護師です。医療的ケア児の在宅ケアに関する相談を多く受けてきました。吸引や経管栄養など、日常のケアで困っていることがあれば、お気軽にご相談ください。',
    expertise: ['吸引ケア', '経管栄養', '感染症対策', '在宅医療'],
    avatar_url: 'https://public.readdy.ai/ai/img_res/229504609f689f2f5378c7907f14cc87.jpg',
    reply_count: 48,
    thanks_count: 156,
    joined_at: '2024-04-01',
  },
  {
    id: 'partner-007',
    nickname: '伊藤 さくら',
    partner_role: '看護師',
    area: '宮城県石巻市',
    workplace: {
      name: 'ひまわり訪問看護ステーション',
      url: '',
    },
    sns: {
      instagram: '',
      twitter: 'https://twitter.com/sakura_nurse',
      line: '',
    },
    bio: '訪問看護ステーションで医療的ケア児のケアを担当しています。ご家庭での医療機器の管理や緊急時の対応など、在宅での不安を一緒に解消していきましょう。',
    expertise: ['訪問看護', '医療機器管理', '緊急対応', '服薬管理'],
    avatar_url: 'https://readdy.ai/api/search-image?query=Caring%20Japanese%20female%20nurse%20in%20her%20late%2020s%20with%20gentle%20professional%20smile%20wearing%20light%20blue%20scrubs%20soft%20natural%20studio%20lighting%20clean%20minimal%20cream%20background%20portrait%20photography%20style&width=400&height=400&seq=partner-nurse2&orientation=squarish',
    reply_count: 32,
    thanks_count: 94,
    joined_at: '2024-09-01',
  },
  {
    id: 'partner-002',
    nickname: '佐藤 恵子',
    partner_role: '先輩ママ',
    area: '宮城県仙台市',
    workplace: null,
    sns: {
      instagram: 'https://instagram.com/keiko_mama',
      twitter: '',
      line: 'https://line.me/ti/p/keiko_mama',
    },
    bio: '気管切開と胃ろうのある6歳の息子を育てています。保育園探しから就学準備まで、たくさんの壁を乗り越えてきました。「一人じゃないよ」と伝えたくて、パートナーになりました。',
    expertise: ['気管切開ケア', '保育園入園', '就学準備', '兄弟児のケア'],
    avatar_url: 'https://readdy.ai/api/search-image?query=Warm%20caring%20Japanese%20mother%20in%20her%20late%2030s%20with%20gentle%20reassuring%20smile%20casual%20comfortable%20clothing%20soft%20natural%20lighting%20clean%20minimal%20cream%20background%20portrait%20photography%20style&width=400&height=400&seq=partner-mom1&orientation=squarish',
    reply_count: 72,
    thanks_count: 234,
    joined_at: '2024-03-15',
  },
  {
    id: 'partner-003',
    nickname: '山本 あかり',
    partner_role: '保育士',
    area: '宮城県名取市',
    workplace: {
      name: 'なとり医療的ケア児保育園',
      url: 'https://www.natori-city.jp/',
    },
    sns: {
      instagram: 'https://instagram.com/akari_hoiku',
      twitter: 'https://twitter.com/akari_hoiku',
      line: '',
    },
    bio: '医療的ケア児を受け入れる保育園で5年間勤務しています。お子さんの集団生活への参加や、保育園との連携方法についてアドバイスできます。入園準備で不安なことがあれば、ぜひお話しください。',
    expertise: ['保育園生活', '集団活動', '発達支援', '園との連携'],
    avatar_url: 'https://readdy.ai/api/search-image?query=Friendly%20Japanese%20female%20nursery%20teacher%20in%20her%20late%2020s%20with%20cheerful%20bright%20smile%20wearing%20pastel%20colored%20apron%20soft%20natural%20lighting%20clean%20minimal%20cream%20background%20portrait%20photography%20style&width=400&height=400&seq=partner-teacher1&orientation=squarish',
    reply_count: 35,
    thanks_count: 98,
    joined_at: '2024-06-01',
  },
  {
    id: 'partner-008',
    nickname: '小林 由美',
    partner_role: '保育士',
    area: '宮城県多賀城市',
    workplace: {
      name: 'たがじょうインクルーシブ保育園',
      url: 'https://www.city.tagajo.miyagi.jp/',
    },
    sns: {
      instagram: '',
      twitter: '',
      line: 'https://line.me/ti/p/yumi_hoiku',
    },
    bio: '障害児保育の専門研修を受け、インクルーシブ保育を実践しています。お子さん一人ひとりの個性を大切にした保育についてお話しできます。',
    expertise: ['インクルーシブ保育', '個別支援計画', '保護者連携', '遊びの工夫'],
    avatar_url: 'https://readdy.ai/api/search-image?query=Warm%20Japanese%20female%20nursery%20teacher%20in%20her%20early%2030s%20with%20kind%20nurturing%20smile%20wearing%20colorful%20casual%20outfit%20soft%20natural%20lighting%20clean%20minimal%20cream%20background%20portrait%20photography%20style&width=400&height=400&seq=partner-teacher2&orientation=squarish',
    reply_count: 28,
    thanks_count: 76,
    joined_at: '2024-10-01',
  },
  {
    id: 'partner-004',
    nickname: '鈴木 健太',
    partner_role: '理学療法士',
    area: '宮城県仙台市',
    workplace: {
      name: '東北こどもリハビリテーションセンター',
      url: 'https://www.pref.miyagi.jp/',
    },
    sns: {
      instagram: '',
      twitter: 'https://twitter.com/kenta_pt',
      line: '',
    },
    bio: '小児リハビリテーション専門の理学療法士です。お子さんの運動発達や姿勢管理、補装具の選び方など、リハビリに関することなら何でもご相談ください。ご家庭でできる簡単な運動もお伝えします。',
    expertise: ['運動発達', '姿勢管理', '補装具', '家庭リハビリ'],
    avatar_url: 'https://readdy.ai/api/search-image?query=Kind%20Japanese%20male%20physical%20therapist%20in%20his%20early%2030s%20with%20warm%20professional%20smile%20wearing%20polo%20shirt%20soft%20natural%20lighting%20clean%20minimal%20cream%20background%20portrait%20photography%20style&width=400&height=400&seq=partner-pt1&orientation=squarish',
    reply_count: 29,
    thanks_count: 87,
    joined_at: '2024-07-10',
  },
  {
    id: 'partner-009',
    nickname: '渡辺 麻衣',
    partner_role: '理学療法士',
    area: '宮城県大崎市',
    workplace: {
      name: '大崎市民病院 リハビリテーション科',
      url: 'https://www.h-osaki.jp/',
    },
    sns: {
      instagram: 'https://instagram.com/mai_pt_kids',
      twitter: '',
      line: '',
    },
    bio: '小児専門病院でリハビリを担当しています。座位保持や移動の工夫、遊びを通じた発達促進など、お子さんの可能性を広げるお手伝いをします。',
    expertise: ['座位保持', '移動支援', '発達促進', '遊びリハビリ'],
    avatar_url: 'https://readdy.ai/api/search-image?query=Friendly%20Japanese%20female%20physical%20therapist%20in%20her%20late%2020s%20with%20encouraging%20smile%20wearing%20athletic%20wear%20soft%20natural%20lighting%20clean%20minimal%20cream%20background%20portrait%20photography%20style&width=400&height=400&seq=partner-pt2&orientation=squarish',
    reply_count: 24,
    thanks_count: 68,
    joined_at: '2024-11-01',
  },
  {
    id: 'partner-005',
    nickname: '高橋 ゆり',
    partner_role: '先輩ママ',
    area: '宮城県塩竈市',
    workplace: null,
    sns: {
      instagram: 'https://instagram.com/yuri_mama_care',
      twitter: 'https://twitter.com/yuri_mama_care',
      line: '',
    },
    bio: '人工呼吸器を使う4歳の娘がいます。NICUからの退院、在宅移行、訪問看護の利用など、すべてが手探りでした。同じ道を歩むママたちの力になりたいです。夜中の不安も、一緒に乗り越えましょう。',
    expertise: ['人工呼吸器', 'NICU退院準備', '訪問看護', '夜間ケア'],
    avatar_url: 'https://readdy.ai/api/search-image?query=Compassionate%20Japanese%20mother%20in%20her%20early%2030s%20with%20hopeful%20gentle%20smile%20wearing%20soft%20knit%20sweater%20warm%20natural%20lighting%20clean%20minimal%20cream%20background%20portrait%20photography%20style&width=400&height=400&seq=partner-mom2&orientation=squarish',
    reply_count: 53,
    thanks_count: 189,
    joined_at: '2024-05-20',
  },
  {
    id: 'partner-010',
    nickname: '木村 香織',
    partner_role: '先輩ママ',
    area: '宮城県登米市',
    workplace: null,
    sns: {
      instagram: '',
      twitter: '',
      line: 'https://line.me/ti/p/kaori_mama',
    },
    bio: '重症心身障害のある8歳の娘を育てています。特別支援学校への就学、レスパイトケアの活用など、長い道のりを歩んできました。一緒に悩み、一緒に笑いましょう。',
    expertise: ['特別支援学校', 'レスパイトケア', '福祉サービス', '家族のケア'],
    avatar_url: 'https://readdy.ai/api/search-image?query=Supportive%20Japanese%20mother%20in%20her%20late%2030s%20with%20understanding%20warm%20smile%20wearing%20comfortable%20cardigan%20soft%20natural%20lighting%20clean%20minimal%20cream%20background%20portrait%20photography%20style&width=400&height=400&seq=partner-mom3&orientation=squarish',
    reply_count: 45,
    thanks_count: 167,
    joined_at: '2024-04-15',
  },
  {
    id: 'partner-006',
    nickname: '中村 真理',
    partner_role: '社会福祉士',
    area: '宮城県仙台市',
    workplace: {
      name: '仙台市障害者相談支援センター',
      url: 'https://www.city.sendai.jp/',
    },
    sns: {
      instagram: '',
      twitter: 'https://twitter.com/mari_sw',
      line: '',
    },
    bio: '障害児福祉の相談支援専門員として8年間活動しています。福祉サービスの利用方法、受給者証の申請、放課後等デイサービスの選び方など、制度面でのサポートが得意です。',
    expertise: ['福祉制度', '相談支援', '放課後デイ', 'サービス利用'],
    avatar_url: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20female%20social%20worker%20in%20her%20mid%2035s%20with%20calm%20trustworthy%20smile%20wearing%20business%20casual%20outfit%20soft%20natural%20lighting%20clean%20minimal%20cream%20background%20portrait%20photography%20style&width=400&height=400&seq=partner-sw1&orientation=squarish',
    reply_count: 41,
    thanks_count: 132,
    joined_at: '2024-08-01',
  },
  {
    id: 'partner-011',
    nickname: '松本 裕子',
    partner_role: '社会福祉士',
    area: '宮城県気仙沼市',
    workplace: {
      name: '気仙沼市児童発達支援センター',
      url: 'https://www.kesennuma.miyagi.jp/',
    },
    sns: {
      instagram: 'https://instagram.com/yuko_sw',
      twitter: '',
      line: 'https://line.me/ti/p/yuko_sw',
    },
    bio: '児童発達支援センターで相談員をしています。障害児福祉手当や特別児童扶養手当の申請、各種制度の活用方法など、お金や制度の不安を解消するお手伝いをします。',
    expertise: ['手当申請', '制度活用', '児童発達支援', '地域連携'],
    avatar_url: 'https://readdy.ai/api/search-image?query=Reliable%20Japanese%20female%20social%20worker%20in%20her%20early%2040s%20with%20reassuring%20professional%20smile%20wearing%20smart%20casual%20blazer%20soft%20natural%20lighting%20clean%20minimal%20cream%20background%20portrait%20photography%20style&width=400&height=400&seq=partner-sw2&orientation=squarish',
    reply_count: 38,
    thanks_count: 115,
    joined_at: '2024-09-15',
  },
];
